import React from "react";

const Sat = () => {
  return <div>Sat</div>;
};

export default Sat;
